var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"header-action-button px-0",attrs:{"elevation":"0","disabled":_setup.compDisabled},on:{"click":_setup.onClick}},[_c(_setup.Icon,{attrs:{"small":_vm.small,"color":_vm.iconColor,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }